export default {
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      totalCount: 0,
      totalPage: 0
    }
  }
}